import * as React from 'react'
import { Link } from 'react-router-dom'
import { ISettingItem } from '../../types/global-settings'
import PencilIcon from '../icons/ui/Pencil'
import TrashIcon from '../icons/ui/Trash'

interface ISettingListItemProps extends ISettingItem {
  baseUrl: string
}

const SettingListItem = (props: ISettingListItemProps) => (
  <div className='flex justify-between'>
    <div className='h5 font-black'>{props.label}</div>
    <div className='h5 font-black'>
      <span>
        <Link to={`${props.baseUrl}/edit/${props.id}`} className='mr1'>
          <PencilIcon className='icon--small svg-fill-grey ml1' />
        </Link>
        <Link to={`${props.baseUrl}/remove/${props.id}`}>
          <TrashIcon className='icon--small svg-fill-grey ml1' />
        </Link>
      </span>
    </div>
  </div>
)

export default SettingListItem



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingListItem.tsx